import { createAsyncThunk } from "@reduxjs/toolkit"

import store from "../../store"

import { doctorList } from "./doctor.service"

export const fetchDoctorsList = createAsyncThunk(
  "doctorService/fetchDoctorsList",
  async (_, { rejectWithValue }) => {
    const orgId = store.getState().userService.user.current_orgId
    try {
      const response = await doctorList(orgId)
      if (!response?.result) return rejectWithValue(null)
      return response
    } catch (err) {
      return rejectWithValue(null)
    }
  },
)
